import Abstract from "./abstract";
import {CodeFormType} from "../consts/consts";
import {commonEventEmitter} from "../../commonEventEmitter";

export default class Code extends Abstract {
  constructor(loginContainer, formSelector, api, errorView) {
    super(loginContainer, formSelector);

    this._codeDigitsInputs = this._form.querySelectorAll(`.js-login-code-digit`);
    this._codeFullCodeInput = this._form.querySelector(`[data-type="code"]`);

    this._errorView = errorView;

    this._location = window.location;

    this._api = api;

    this._captcha.type = `code`;

    commonEventEmitter.on(`captcha.get`, this._onCaptchaGet);
    commonEventEmitter.on(`captcha.remove`, this._onCaptchaRemove);
  }

  setInputPhoneNumberValue(phone) {
    Array.from(this._inputsElements).find((element) => element.dataset.type === `tel`).value = phone;
  }

  // TODO: Добавить keydown обработчик
  // codeInputsElements.forEach((input, index) => {
  // input.addEventListener(`keydown`, (evt) => {
  // if (evt.key === `Backspace` && index !== 0) {
  // input.value = ``;
  // codeInputsElements[index - 1].focus();
  // }
  // });

  sendCodeToServer(type) {
    if (!this._captcha.token) return;

    const data = new FormData(this._form);

    data.set(`smart-token`, this._captcha.token);

    switch (type) {
      case CodeFormType.REGISTRATION:
        this._api.sendRegistrationCode(data).then((result) => this._processingServerResponse(result, type));
        break;
      case CodeFormType.LOG_IN:
        this._api.sendLoginCode(data).then((result) => this._processingServerResponse(result, type));
        break;
    }
  }

  updateCode() {
    this._codeFullCodeInput.value = ``;

    this._codeDigitsInputs.forEach((input) => (this._codeFullCodeInput.value = `${this._codeFullCodeInput.value}${input.value}`));
  }

  changeFormSubmitStatus(evt) {
    super.changeFormSubmitStatus(evt);

    this.updateCode();

    if (!this._validateInput(`code`)) {
      evt.preventDefault();
    } else {
      evt.preventDefault();
      const type = this._loginContainer.classList.contains(`login__content--registration`)
        ? CodeFormType.REGISTRATION
        : CodeFormType.LOG_IN;
      this.sendCodeToServer(type);
    }
  }

  inputCode(evt, index) {
    const self = evt.currentTarget;
    if (self.value.length === 1 && index + 1 < this._codeDigitsInputs.length) {
      this._codeDigitsInputs[index + 1].focus();
    }
  }

  _onCaptchaRemove = () => {
    this._captcha.token = null;
  };

  _onCaptchaGet = (token, type) => {
    this._captcha.token = token ? token : null;

    this.updateCode();

    if (type === this._captcha.type && this._validateInput(`code`)) {
      const type = this._loginContainer.classList.contains(`login__content--registration`)
        ? CodeFormType.REGISTRATION
        : CodeFormType.LOG_IN;
      
      this.sendCodeToServer(type);
    }
  };

  _processingServerResponse(data, type) {
    super._processingServerResponse(data, type);

    if (data.code === 200) {
      if (this._errorView.isShowedError()) {
        this._errorView.hideError();
      }

      this._location.href = type === CodeFormType.LOG_IN ? `/` : `/user`;
    } else if (data.code === 400) {
      this._errorView.showError(`Код введен не верно`);
    } else {
      this._errorView.showError(data.answer);
    }
  }

  _watchDigitInput(evt, index) {
    this._callback.digitInput(evt, index);
  }

  setDigitInputHandler(callback) {
    this._callback.digitInput = callback;
    this._codeDigitsInputs.forEach((codeDigit, index) => codeDigit.addEventListener(`input`, (evt) => this._watchDigitInput(evt, index)));
  }
}
